{
    "TelephoneserverLabel": "Telefoonserver:",
    "PartitionsLabel": "Een geldige waarde(n) van PartIDInTelSys moet worden opgegeven in de container van de Scopes. Een of meer waarde(n) van PartIDInTelSys zijn ongeldig '|1'.",
    "ScopeFiltering_SectionHeader": "Bereikfiltering",
    "NAME": "ScopeFiltering",
    "ScopeGroupsLabel": "Bereikgroep(en):",
    "AnyScopeGroupsLabel": "[Elke bereikgroep]"
}